'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgTablet(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M4.999 2.002L10.853 2c.497 0 .677.052.858.149.182.097.324.24.422.421.087.163.138.326.147.719l.001 9.283c0 .496-.051.676-.148.858-.098.182-.24.324-.422.421-.181.097-.361.149-.858.149H5.138c-.496 0-.676-.052-.858-.149a1.012 1.012 0 01-.421-.421c-.088-.163-.138-.326-.147-.719L3.71 3.428c0-.496.052-.676.149-.858.097-.182.24-.324.421-.421.163-.088.326-.138.719-.147zm2.994 10.284a.434.434 0 00-.426.43.43.43 0 00.426.427.434.434 0 00.431-.426.44.44 0 00-.43-.431zm2.628-9H5.37c-.184 0-.337.144-.37.334l-.005.073v7.328a.4.4 0 00.307.401l.068.007h5.25c.184 0 .337-.144.369-.334l.006-.074V3.693a.4.4 0 00-.308-.4l-.067-.007z", fill: "currentColor" }))));
}

module.exports = SvgTablet;
//# sourceMappingURL=Tablet.js.map
